import React from 'react';
import PropTypes from 'prop-types';

const PreviousPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M5 4c-.553 0-1 .488-1 1.091v21.818C4 27.512 4.447 28 5 28h2c.552 0 1-.488 1-1.091V5.091C8 4.488 7.552 4 7 4H5zm21.71.639L10.785 15.111a1.056 1.056 0 0 0 0 1.778L26.71 27.362a.84.84 0 0 0 .463.138.816.816 0 0 0 .827-.804V5.305a.786.786 0 0 0-.142-.451.831.831 0 0 0-.686-.354.835.835 0 0 0-.462.139z"
    />
  );
};

PreviousPath.propTypes = {
  fill: PropTypes.string,
};

export default PreviousPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/previous.jsx